import { IconShare } from "@/assets/icons/geist/IconShare";
import { Button } from "@/components/flexkit/Button";
import { useCurrentMember } from "@/hooks/use-current-member";
import { useShareResource } from "@/hooks/use-share-resource";
import { useProject } from "@/queries/project-queries";
import { ResourceType } from "gitpod-next-api/gitpod/v1/event_pb";
import { OrganizationRole } from "gitpod-next-api/gitpod/v1/organization_pb";
import { type FC } from "react";

type ShareProjectButtonProps = {
    projectId: string;
};

export const ShareProjectButton: FC<ShareProjectButtonProps> = ({ projectId }) => {
    const { openShareDialog } = useShareResource();
    const { data: project } = useProject(projectId);
    const { currentMember } = useCurrentMember();

    const isAdmin = currentMember?.role === OrganizationRole.ADMIN;

    // TODO: Currently project:grant doesn't actually allow sharing.
    // Once the permission system properly supports project:grant for sharing operations,
    // add permission-based check using useResourcePermissions and useFlagGroupManagementEnabled:
    // const { value: isGroupManagementEnabled } = useFlagGroupManagementEnabled();
    // const { hasPermission } = useResourcePermissions({ enabled: isGroupManagementEnabled });
    // const canShareProject = isGroupManagementEnabled
    //     ? hasPermission(ResourceType.PROJECT, projectId, "project:grant")
    //     : isAdmin;

    const canShareProject = isAdmin;

    const handleShareClick = () => {
        if (project) {
            openShareDialog({
                resourceType: ResourceType.PROJECT,
                resourceId: project.id,
                resourceName: project.metadata?.name || "Untitled Project",
            });
        }
    };

    if (!canShareProject) {
        return null;
    }

    return (
        <Button
            variant="outline"
            onClick={handleShareClick}
            disabled={!project}
            data-testid="share-project-button"
            data-tracking-id="share-project-button"
            LeadingIcon={IconShare}
            size={"sm"}
        >
            Share
        </Button>
    );
};
